import { useState } from "react";
import DatePicker from "react-date-picker";
import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

const RequestLeaveForm = ({ onSubmit, onCloseClicked }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [reason, setReason] = useState('');

  const handleSubmit = e => {
    e.preventDefault();

    onSubmit({
      startDate: formatDateToSydneyTimeZone(startDate, 'yyyy-MM-dd'),
      endDate: formatDateToSydneyTimeZone(endDate, 'yyyy-MM-dd'),
      reason
    });
  }

  return (
    <div className="bg-white rounded-lg shadow-md shadow-ase-blue w-full md:w-auto md:min-w-[600px]">
      <div className="flex items-center justify-between text-lg border-b bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Request Leave</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="py-2 px-4"
      >
        <div className="flex items-center justify-center gap-4 mb-4 mt-2">
          <label className="flex flex-col gap-1 w-full">
            Start date

            <DatePicker
              value={startDate}
              onChange={setStartDate}
              required={true}
              clearIcon={null}
              format="d/M/yyyy"
              className="h-[46px]"
              maxDetail="month"
              minDetail="year"
            />
          </label>

          <label className="flex flex-col gap-1 w-full">
            End date

            <DatePicker
              value={endDate}
              onChange={setEndDate}
              minDate={startDate || null}
              required={true}
              clearIcon={null}
              format="d/M/yyyy"
              className="h-[46px]"
              maxDetail="month"
              minDetail="year"
            />
          </label>
        </div>

        <label className="flex flex-col gap-2 mb-4">
          <span>Reason</span>

          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full min-h-[200px] border rounded-md p-2"
          />
        </label>

        <button
          type="submit"
          className="w-full bg-ase-blue text-white font-semibold h-[48px] rounded-md"
        >
          Submit
        </button>
      </form>
    </div>
  )
}

export default RequestLeaveForm;
